import { down } from 'styled-breakpoints';
import styled from 'styled-components';

interface isAdminProp {
    isAdmin: boolean | undefined;
    emptyAnchors?: boolean | undefined;
}
export const StyledSectionHeader = styled.div`
    position: relative;
    &:not([data-cover='true']) {
        background-color: #00565b;
    }

    overflow: hidden;

    color: ${({ theme }) => theme.palette.common.white};
    margin: ${({ theme }) => `-${theme.spacers.medium}`};

    margin-bottom: ${({ theme }) => theme.spacers.medium};
    border-radius: 24px;

    display: flex;
    justify-content: center;
    flex-direction: column;

    ${down('md')} {
        padding: 0 16px;
    }
    ${down('sm')} {
        padding: 0px;
        margin: -16px;
        margin-bottom: 30px;
        align-items: center;
    }

    .cover_img_wrap {
        position: absolute;
        z-index: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .cover_img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
    }

    min-height: 200px;
`;
export const TitleWrapper = styled.div<isAdminProp>`
    border-radius: 24px;
    display: flex;
    flex-direction: ${({ emptyAnchors }) => (!emptyAnchors ? 'row' : 'row')};
    justify-content: space-between;
    width: 100%;

    padding: 60px;

    position: relative;

    ${down('xxl')} {
        padding: 62px;
    }
    ${down('lg')} {
        padding: 30px;
    }
    ${down('md')} {
        padding: 16px;
    }

    .content-title {
        min-height: 60px;
        display: flex;
        align-items: center;
        font-size: 36px;
        font-family: Arial;
        font-weight: 700;
        line-height: normal;
        margin-top: 0;
        margin-bottom: 0;
        color: ${({ theme }) => theme.palette.common.white};
        text-shadow: 0 0 30px rgb(0 0 0 / 70%);

        &[data-cover-loading='true'] {
            text-shadow: none;
            color: ${({ theme }) => theme.palette.common.black} !important;
        }

        max-width: calc(100% - 303px);

        ${down('xxl')} {
            min-height: 36px;
            max-width: calc(100% - 84px);
        }
        ${down('lg')} {
            font-size: 24px;
            max-width: calc(100% - 243px);
        }
        ${down('md')} {
            font-size: 18px;
            max-width: calc(100% - 64px);
        }
    }
    @media screen and (max-width: 1800px) {
        ${({ isAdmin }) => (isAdmin ? 'flex-direction: column;' : undefined)};
        ${({ isAdmin }) => (isAdmin ? ' row-gap: 20px;' : undefined)};
    }
    ${down('lg')} {
        flex-wrap: nowrap;
        row-gap: 20px;
    }
    @media screen and (max-width: 1200px) {
        flex-direction: ${({ emptyAnchors }) => (emptyAnchors ? 'row' : 'row')};
    }
`;

export const MobileButtonWrapper = styled.div<isAdminProp>`
    display: flex;
    flex-direction: row;
    column-gap: 15px;
    row-gap: 15px;
    position: relative;

    & > a > {
        ${({ isAdmin }) => (isAdmin ? 'pointer-events: none;' : undefined)};
    }

    .anchors {
        display: none;
    }
    min-width: 100%;

    ${down('lg')} {
        .anchors {
            display: flex;
            width: 100%;
            padding: 32px;
            padding-top: 0;
            & > a {
                width: 100%;
                display: flex;
                flex: 3;
            }
        }
    }
    ${down('md')} {
        .anchors {
            display: flex;
            width: 100%;
            padding: 16px;
            padding-top: 0;
            & > a {
                width: 100%;
                display: flex;
                flex: 3;
            }
        }
    }
`;
export const MobileButton = styled.a`
    flex-direction: row;
    grid-column-gap: 15px;
    column-gap: 15px;
    max-width: 360px;
    height: 57px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 0;
    align-self: flex-start;
    margin-left: 20px;
    position: relative;
    padding: 0 20px;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    cursor: pointer;
    background-color: #fff;

    transition: 0.3s;

    &:hover {
        transition: 0.3s;
        background-color: rgb(242, 242, 242);
    }
    ${down('lg')} {
        height: auto;
        padding: 6px 10px;
        font-size: 14px;
    }
`;

export const MobileButtonTitle = styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 20px;
    color: ${({ theme }) => theme.palette.common.black};
    ${down('xl')} {
        display: none;
    }

    ${down('lg')} {
        display: block;
        font-size: 16px;
    }
    ${down('md')} {
        display: none;
    }
`;

export const AnchorsWrapper = styled.div<isAdminProp>`
    display: flex;
    flex-wrap: wrap;
    position: relative;

    column-gap: 10px;
    row-gap: 10px;

    grid-column-gap: 10px;
    grid-row-gap: 10px;

    padding: 60px;
    padding-top: 0;

    ${down('lg')} {
        display: none;
    }
    & > a {
        ${down('xl')} {
            ${({ isAdmin }) => (isAdmin ? 'width: 100%;' : undefined)};
        }
        ${({ isAdmin }) => (isAdmin ? 'pointer-events: none;' : undefined)};
        & > button {
            ${down('xl')} {
                ${({ isAdmin }) => (isAdmin ? 'width: 100%;' : undefined)};
                ${({ isAdmin }) => (isAdmin ? 'max-width: 320px;' : undefined)};
            }
        }
    }
`;
export const AnchorButton = styled.button`
    display: flex;
    height: 50px;
    max-height: 50px;
    max-width: 328px;
    background-color: ${({ theme }) => theme.palette.common.white};
    padding: 10px 20px;
    border-radius: ${({ theme }) => theme.borderRadius.buttons};
    align-items: center;
    justify-content: center;
    cursor: pointer;

    transition: 0.3s;
    &:hover {
        transition: 0.3s;
        background-color: rgb(242, 242, 242);
    }
`;
export const AnchorTitle = styled.span`
    display: block;
    position: relative;
    width: 100%;
    color: ${({ theme }) => theme.palette.common.black};
    font-size: 18px;
    line-height: 1.6;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
`;
